// eslint-disable-next-line
import React, { useEffect } from 'react';
import { message, Tag, Menu, Dropdown } from 'antd';
import ShiftAvatar from './shiftAvatar';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'appRedux/reducers/ReducerState';
import { changeWorkShift, resetProcessStatus } from 'appRedux/actions/Auth';
import styled from 'styled-components';
import permissionVerify from 'util/permissionVerify';

const StyledShiftMenu = styled(Menu)`
  border-radius: 12px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.2);
  overflow-y: auto;
  max-height: 250px;
  padding: 0 !important;

  .ant-dropdown-menu-item {
    font-weight: 500;
    font-size: 15px;
    color: #1677ff;
    padding: 10px 20px;
    transition:
      background 0.2s,
      color 0.2s;

    &:hover {
      background-color: #cceeff;
      color: #0958d9;
    }
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #91d5ff;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
export const CurrentTag: React.FC = () => {
  const {
    auth: { authUser, process },
  } = useSelector((state: any) => state);
  const systemConfig = useSelector((state: AppState) => state.systemConfig);
  const { dataSource: dataSourceConfig } = systemConfig;

  const dispatch = useDispatch();

  const WORKING_SHIFT = dataSourceConfig?.SYSTEM?.SHIFTS || [];
  const CURRENT_SHIFT = authUser?.current_shift || '';
  const user_id = authUser?.user_id;
  const prop_id = authUser?.prop_id;

  const menu = () => {
    return (
      <>
        {/* {permissionVerify('30001') && ()} */}
        <StyledShiftMenu onClick={onHandleChange}>
          {WORKING_SHIFT.map((obj: any) => (
            <Menu.Item key={obj}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <ShiftAvatar
                  size={20}
                  style={{
                    background: 'linear-gradient(135deg, #52c41a, #73d13d)',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 12,
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                    border: '1px solid #34a853',
                  }}
                >
                  {obj.toUpperCase()}
                </ShiftAvatar>
                <span>Shift {obj}</span>
              </div>
            </Menu.Item>
          ))}
        </StyledShiftMenu>
      </>
    );
  };

  const onHandleChange = (value: any) => {
    dispatch(changeWorkShift({ workShift: value?.key, user_id, prop_id }));
  };

  useEffect(() => {
    const action_validate = ['authChangeWorkShift'];
    const error_code = ['1', '2', '4', 'ERROR'];
    if (action_validate.includes(process?.action)) {
      if (process.status && !error_code.includes(process.result_code))
        message.success(process.message.toString());
      else message.error(process.message.toString());

      setTimeout(() => {
        dispatch(resetProcessStatus());
      }, 100);
    }
  }, [process, dispatch]);

  return (
    <Dropdown popupRender={() => menu()} placement='bottomLeft' trigger={['click']}>
      {/* <ShiftTag> */}
      <div className='inline-flex items-center justify-center gap-1.5 bg-[#e6f7ff] py-[6px] px-[12px] rounded-full font-[600] text-sm text-[#1890ff] cursor-pointer border border-[#91d5ff] shadow-sm hover:bg-[#bae7ff] hover:border-[#69c0ff] transition-colors duration-200 select-none'>
        <ShiftAvatar
          size={18}
          style={{
            background: 'linear-gradient(135deg, #52c41a, #73d13d)',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: 11,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
            border: '1px solid #34a853',
          }}
        >
          {CURRENT_SHIFT.toUpperCase()}
        </ShiftAvatar>
        <span className='hidden md:inline-block whitespace-nowrap leading-none'>Current Shift</span>
      </div>
      {/* </ShiftTag> */}
    </Dropdown>
  );
};
export default CurrentTag;
